<!--
 * @Description: ================== 游戏介绍 =================
 * @Date: 2022-05-13 18:08:07
 * @Author: Zero
 * @FilePath: \guobao-web\src\components\Game.vue
 * @LastEditors: Zero
 * @LastEditTime: 2022-06-14 14:51:49
-->
<template>
  <div class="page page-game">
    <div style="margin-top:20px">
      <img src="/banner.jpg" alt="" style="width: 100%" />
    </div>
    <h2 class="title">游戏介绍</h2>
    <p>《觉醒大冒险》是一款宝可梦 IP 二次元卡牌手游，延续原作冒险世界观，还原鲜活完整的宝可梦世界。集结全系列经典人气小精灵，融合卡牌收集、策略布阵与深度养成玩法，搭配专属羁绊联动，征战冒险领地、挑战强悍神兽 BOSS，开启专属于你的宝可梦冒险征程！</p>
    <!-- <pre> -->
    <div class="content">
      <div class="content-item">
        <h4>【宝可梦全新冒险启程】</h4>
          踏入色彩鲜活的宝可梦世界，在这里邂逅海量经典小精灵。熟悉的原作形象全新演绎，高清卡通画风还原小镇风光，沉浸式开启属于你的训练家旅途，收集各式精灵伙伴，组建专属冒险小队。
        <img src="/1.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【策略卡组随心构筑】</h4>
          主打轻松有趣的卡牌回合对战，灵活搭配不同宝可梦的技能特性。没有固定强势阵容，依靠策略排布打出多样战斗效果，巧妙克制对手阵容，体验脑力博弈带来的战斗快感。
        <img src="/2.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【多元玩法丰富体验】</h4>
          游戏内包含召唤抽卡、饲育养成、研究所培育、贸易中心等丰富系统。扭蛋机抽取稀有精灵，培育屋强化伙伴实力，各类限时活动、签到福利源源不断，日常玩法充实不枯燥。
        <img src="/3.jpg" alt="" />
      </div>
      <div class="content-item">
        <h4>【并肩奔赴对战赛场】</h4>
          集结你的强力宝可梦阵容，挑战各类关卡与对手。参与联盟玩法与其他训练家同台竞技，不断培养提升精灵战力，解锁更多高阶精灵，向着顶尖宝可梦训练家的目标不断前进。
        <img src="/4.jpg" alt="" />
      </div>
    </div>
    <!-- </pre> -->
  </div>
</template>

<style scss>
.content-item {
  display: inline-block;
  width: 50%;
  padding: 12px;
  box-sizing: border-box;
  vertical-align: top;
}
.content-item img {
  display: block;
  margin-top: 12px;
  width: 400px;
}
@media screen and (max-width: 768px) {
  .content-item {
    width: 100%;
  }
  .content-item img {
    width: 100%;
  }
}
</style>
